import { useContext, useState } from 'react';
import { ClientItem, ClientsList, Drawer, DrawerContent, DrawerTrigger } from '@components';
import { CONSTANT_OTHER_ENTITIES_LITERAL } from '@components/layouts/main/MainLayout';
import { CONSTANT } from '@const';
import { AccountContext, LegalEntityContext, ScreenSizeContext } from '@context';
import { Arrow } from '@public';

import styles from './clientMobile.module.scss';

export const ClientMobile = () => {
	const { isSmallDT, isMobile, isTablet } = useContext(ScreenSizeContext);
	const { legalEntity, legalEntityList, filteredLegalEntityList } = useContext(LegalEntityContext);
	const { getUserAccount } = useContext(AccountContext);
	const hasEntities = legalEntityList.length;
	const drawerDirection = isMobile || isTablet ? 'bottom' : 'right';

	const [openDrawer, setOpenDrawer] = useState(false);

	return (
		<>
			{isSmallDT && (
				<>
					<div className={styles.user}>
						{getUserAccount.isLoading ? (
							<div className={styles['user-name']}>
								<p className={` ${styles.skeleton} ${styles[`user-name-skeleton`]} `} />
							</div>
						) : (
							<p className={styles['user-name']}>
								{getUserAccount.data &&
									`${CONSTANT.WELCOME_BACK} ${getUserAccount.data.firstName},`}
							</p>
						)}
						<div className={styles['user-select']}>
							{hasEntities || status != 'error' ? (
								<ClientItem clientItem={legalEntity} showAddress={false} />
							) : (
								<ClientItem />
							)}
						</div>
						{legalEntityList && legalEntityList.length > 1 && (
							<div className={styles.selectEntitiesButtonContainer}>
								<Drawer direction={drawerDirection} open={openDrawer} onOpenChange={setOpenDrawer}>
									<DrawerTrigger className={styles.clientSelectionButton}>
										<span className={styles.selectEntitiesTitleButton}>
											<span data-testid="otherEntities">{CONSTANT_OTHER_ENTITIES_LITERAL}</span>
											<Arrow customStyles={styles.arrow} />
										</span>
									</DrawerTrigger>
									<DrawerContent placement={drawerDirection}>
										<ClientsList
											clients={filteredLegalEntityList}
											onSelect={() => {
												setOpenDrawer(false);
											}}
										/>
									</DrawerContent>
								</Drawer>
							</div>
						)}
					</div>
					<div className={styles['user-seperator']} />
				</>
			)}
		</>
	);
};
